import Rest from '../../Rest'

export default class ReportingChannelFormService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/reporting_channel_form'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getListLegalEntity(paramEncrypt: String) {
    return this.get(`legal_entity/${paramEncrypt}`).then(data => {
      return data
    })
  }

  getCustomerRelationshipList() {
    return this.get(`customer_relationships/`).then(data => {
      return data
    })
  }

  getTypeReportingList() {
    return this.get(`type_reporting/`).then(data => {
      return data
    })
  }

  getKnowFactList() {
    return this.get(`know_facts/`).then(data => {
      return data
    })
  }

  getStatusOfReportList() {
    return this.get(`status_of_report/`).then(data => {
      return data
    })
  }


}
